import React, { FunctionComponent, useEffect, useState } from 'react';
import { observer, Observer } from 'mobx-react';
import styled from 'styled-components';

import AppBar from '@mui/material/AppBar';


import Stack from '@mui/material/Stack';
import { Col, TitleFont } from '../../../libs/base/base-style';
import Profile from './Profile'

import {
    useScrollSections,
} from 'react-scroll-section';
import { StyledBtn } from './styles';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import AppsIcon from '@mui/icons-material/Apps';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';

export const sections = ['Dentist', 'Farrier', 'BodyWork', 'Vet', 'Worming', 'Injection', 'Medication', 'Misc', 'Feed', 'Work', 'Results', 'Broodmare']
export const SectionsConfig = {
    'Dentist': { showContacts: true, recColor: '#408697', contactColor: '#f4f4f4' },
    'Farrier': { showContacts: true, recColor: '#408697', contactColor: '#f4f4f4' },
    'BodyWork': { showContacts: true, recColor: '#408697', contactColor: '#f4f4f4' },
    'Vet': { showContacts: true, recColor: '#408697', contactColor: '#f4f4f4' },
    'Worming': { recColor: '#408697', renameAction: 'Add Worming', subtitle: 'Last Worming' },
    'Injection': { recColor: '#f4f4f4', renameAction: 'Add Injection', subtitle: 'Last Injection' },
    'Medication': { recColor: '#408697', renameAction: 'Add Medication', subtitle: 'Past Medications' },
    'Misc': { recColor: '#f4f4f4' },
    'Feed': { showNotes: true, renameAction: 'Add Feed', recColor: '#408697', subtitle: 'Feed', innerSubtitle: 'Date', noReminder: true },
    'Work': { videoTextfield: true, showContacts: true, recColor: '#f4f4f4', contactColor: '#408697', contactTitle: 'Coach Contact Details', subtitle: 'Last Worked', renameAction: 'Add Work', noReminder: true },
    'Results': { videoTextfield: true, recColor: '#f4f4f4', renameTitle: 'Results:', subtitle: ' ', renameAction: 'Add Results', noReminder: true },
    "Broodmare": { videoTextfield: true, videoTextLabel: 'Stallion', recColor: '#408697', subtitle: 'Foaling Date', renameAction: 'Add Broodmare', renameNotes: 'Scans:', noReminder: false, reminderLable: 'Due Date' }
}
const Header: FunctionComponent<{ horseId?: string }> = (props) => {
    const sections = useScrollSections()
    return <Col>

        <ResponsiveAppBar />

        <Profile profileId={props.horseId} />
    </Col>
}


const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function ResponsiveAppBar() {
    const sections = useScrollSections();
    const navRef = React.useRef<HTMLDivElement | null>(null);
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const [isFixed, setIsFixed] = useState(false);

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    useEffect(() => {
        const handleScroll = () => {
            const navbarHeight = navRef.current?.clientHeight || 0 + 56 + 89 + 32;//document.getElementById('navbar')?.clientHeight || 0;
            console.log(navbarHeight);
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollPosition > navbarHeight && !isFixed) {
                setIsFixed(true);
            } else if (currentScrollPosition <= navbarHeight && isFixed) {
                setIsFixed(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isFixed]);

    return (
        <Styledbar ref={navRef} position={isFixed ? 'fixed' : 'static'} sx={{
            top: { md: isFixed ? '32px' : 0, xs: 0 },
            background: isFixed ? '#1d2327 !important' : '#408697'
        }}>
            <Container maxWidth="xl" >
                <Toolbar disableGutters>
                    <Link to={'/'}>
                        <Typography
                            variant="h5"
                            noWrap
                            component="a"
                            href=""
                            sx={{
                                mr: 2,
                                display: { xs: 'flex', md: 'none' },
                                flexGrow: 1,
                                fontFamily: 'inherit',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'white',
                                textDecoration: 'none',
                            }}
                        >
                            EquiManage
                        </Typography>
                    </Link>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, padding: 0, justifyContent: 'flex-end' }} >
                        <IconButton
                            sx={{ padding: '0 !important', backgroundColor: isFixed ? '#000 !important' : '#408697' }}
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"

                        >
                            <AppsIcon sx={{ padding: 0 }} />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {sections.map(({ id, onClick, selected }) => {
                                return <MenuItem key={id} onClick={() => {
                                    handleCloseNavMenu()
                                    onClick()
                                }}>
                                    <Typography textAlign="center">{id}</Typography>
                                </MenuItem>
                            })}
                        </Menu>
                    </Box>

                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex', justifyContent: 'center', alignItems: "center" } }}>
                        {sections.map(({ id, onClick, selected }) => {
                            return <StyledBtn key={id} size="small" variant="text" onClick={onClick}>{id}</StyledBtn>
                        })}
                    </Box>


                </Toolbar>
            </Container>
        </Styledbar>
    );
}
const HeaderWrapper = styled.div`
    display:flex;
    justify-content: center;
    align-items:center;
    margin-top:10px;
`
const Styledbar = styled(AppBar)`
    background-color:#408697 !important;
    box-shadow: none !important;
    
`
export default Header
